/** DF 可售库存操作日志 — POST /manage/amazonVcDfSellableStock/logList */

/** 接口 data.items[] */
export interface DfSellableOperateLogApiItem {
    id?: string;
    createTimeLabel?: string;
    operatorName?: string;
    action?: number;
    actionLabel?: string;
    logType?: number;
    logTypeLabel?: string;
    detailLabel?: string;
    beforeStock?: number;
    afterStock?: number;
}

/** 弹窗表格行（字段与详情弹窗公共日志列对齐） */
export interface DfOperateLogItem {
    id: string;
    createTime: string;
    operator: string;
    operatorName: string;
    action: string;
    detail: string;
    logType?: number;
    logTypeLabel?: string;
    beforeStock?: number;
    afterStock?: number;
}

export function mapDfSellableOperateLogItem(item: DfSellableOperateLogApiItem): DfOperateLogItem {
    const operatorName = String(item.operatorName ?? "").trim();
    return {
        id: String(item.id ?? ""),
        createTime: String(item.createTimeLabel ?? "").trim() || "--",
        operator: operatorName || "--",
        operatorName: operatorName || "--",
        action: String(item.logTypeLabel ?? "").trim() || "--",
        detail: String(item.detailLabel ?? "").trim(),
        logType: item.logType,
        logTypeLabel: String(item.logTypeLabel ?? "").trim() || undefined,
        beforeStock: item.beforeStock,
        afterStock: item.afterStock,
    };
}

/** 详情拆成摘要 + 失败原因（失败原因单独第二行标红） */
export function splitDfOperateLogDetail(detail: string | null | undefined): { summary: string; failReason: string } {
    const raw = String(detail ?? "").trim();
    if (!raw) return { summary: "", failReason: "" };

    // 优先按「失败原因：」切开（设计稿）
    const reasonMatch = raw.match(/失败原因[：:]/);
    if (reasonMatch?.index != null && reasonMatch.index >= 0) {
        return {
            summary: raw.slice(0, reasonMatch.index).trim(),
            failReason: raw.slice(reasonMatch.index).trim(),
        };
    }

    // 否则从「失败」起作为失败后缀（如：库存数：【100】-> 【100】失败 Amazon reject: ...）
    const failIdx = raw.search(/失败/);
    if (failIdx > 0) {
        return {
            summary: raw.slice(0, failIdx).trim(),
            failReason: raw.slice(failIdx).trim(),
        };
    }
    if (failIdx === 0) {
        return { summary: "", failReason: raw };
    }

    return { summary: raw, failReason: "" };
}
